import { render } from "./UserManagePage.vue?vue&type=template&id=d278d230&scoped=true"
import script from "./UserManagePage.vue?vue&type=script&lang=js"
export * from "./UserManagePage.vue?vue&type=script&lang=js"

import "./UserManagePage.vue?vue&type=style&index=0&id=d278d230&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d278d230"]])

export default __exports__